/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Amount of tax or fee
 * @export
 * @interface TravelineBookingTaxAmountDto
 */
export interface TravelineBookingTaxAmountDto {
    /**
     * Amount of tax or fee
     * @type {number}
     * @memberof TravelineBookingTaxAmountDto
     */
    amount: number;
    /**
     * Link to tax description in a booking
     * @type {number}
     * @memberof TravelineBookingTaxAmountDto
     */
    index: number;
}

/**
 * Check if a given object implements the TravelineBookingTaxAmountDto interface.
 */
export function instanceOfTravelineBookingTaxAmountDto(value: object): value is TravelineBookingTaxAmountDto {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('index' in value) || value['index'] === undefined) return false;
    return true;
}

export function TravelineBookingTaxAmountDtoFromJSON(json: any): TravelineBookingTaxAmountDto {
    return TravelineBookingTaxAmountDtoFromJSONTyped(json, false);
}

export function TravelineBookingTaxAmountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingTaxAmountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'index': json['index'],
    };
}

  export function TravelineBookingTaxAmountDtoToJSON(json: any): TravelineBookingTaxAmountDto {
      return TravelineBookingTaxAmountDtoToJSONTyped(json, false);
  }

  export function TravelineBookingTaxAmountDtoToJSONTyped(value?: TravelineBookingTaxAmountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'index': value['index'],
    };
}

